import { createApp } from 'vue'
import { createPinia } from "pinia"
import vuetify from "@/plugins/vuetify"
import {loadLayouts} from "@/layouts"
import {usePlugins} from "@/plugins"
import App from "./App.vue"
import router from "@/router"
import * as Sentry from "@sentry/vue"
import { App as CapacitorApp } from '@capacitor/app'

const app = createApp(App)

app.use(router)
app.use(vuetify)
app.use(createPinia())

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_APP_ENV,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.browserTracingIntegration({ router }),
    Sentry.captureConsoleIntegration()
  ],
  // Session Replay
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
})
usePlugins(app)
loadLayouts(app)

router.isReady().then(() => {
  app.mount('#app')
})

// when app version is opened with a URL
CapacitorApp.addListener('appUrlOpen', async ({ url }) => {
  if (!url) return

  // remove protocol
  const hostPath = url.replace(/^https?:\/\//, '')

  // get path (everything after the host)
  const path = hostPath.split('/').slice(1).join('/')

  // navigate to path
  await router.replace(path)

  // reload the page
  location.reload()
})

export default app
